import React from 'react';
import {
  ArticleSettings,
} from 'src/infrastructure/gatsby/types/article-settings';
import styled from 'styled-components';
import ArticleCard, { ArticleCardTheme } from '..';

const HorizontalTheme = {
  ...ArticleCardTheme,
  Main: styled(ArticleCardTheme.Main)`
    display: flex;
    width: 100%;
    margin: 0 0 5rem 0 !important;
  `,
  CardImage: styled(ArticleCardTheme.CardImage)`
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 27rem;
    height: 23.4rem;
  `,
  Text: styled(ArticleCardTheme.Text)`
    height: 23.4rem;
  `,
  Title: styled(ArticleCardTheme.Title)`
    height: 6.6rem;
  `,
};

type Props = {
  article: ArticleSettings;
}

const HorizontalArticleCard: React.FC<Props> = ({ article }) => (
  <ArticleCard
    article={article}
    theme={HorizontalTheme}
  />
);

export default HorizontalArticleCard;
